import { makeStyles } from '@material-ui/core/styles';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { color } from '../../../app/theme';
import IconDelete from '../../../assets/images/Icons/IconDelete';
import IconRefresh from '../../../assets/images/Icons/IconRefresh';
import Checkbox from '../../shared/Checkbox';

const useStyles = makeStyles(
  {
    selectAllBlock: {
      marginBottom: 6,
      maxWidth: 714,
      display: 'flex',
      alignItems: 'center',
      fontSize: '13px',
      fontStyle: 'normal',
      fontWeight: '400',
      lineHeight: 'normal',
      color: color.$13,
    },
    icon: {
      marginLeft: 10,
      cursor: 'pointer',
    },
    selectAll: {
      textDecoration: 'underline',
      color: color.$2,
      marginLeft: 10,
      cursor: 'pointer',
    },
  },
  {
    name: 'Selected',
  },
);

const Selected = ({
  datasets,
  selectedList,
  setSelectedList,
  onDelete,
  onRefresh,
  progress,
  dataType,
  onSelectAll,
  isSelectAll,
  total,
}) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const { pathKey } = useSelector(store => store.aiBot);

  return (
    <>
      {!!selectedList.length && (
        <div className={classes.selectAllBlock}>
          <Checkbox
            checked={isSelectAll || selectedList.length === datasets?.length}
            onClick={() => {
              if (isSelectAll || selectedList.length === datasets?.length) {
                setSelectedList([]);
              } else {
                setSelectedList(datasets.map(s => s?.id));
              }
            }}
          />
          {t(`${pathKey}:selected`)} (
          {isSelectAll ? total : selectedList.length})
          <div className={classes.selectAll} onClick={() => onSelectAll(true)}>
            選取全部
          </div>
          <IconDelete
            className={classes.icon}
            id="icon-delete-all"
            width={20}
            height={20}
            color={!progress.done ? color.$9 : color.$12}
            hoverColor={!progress.done ? color.$9 : color.$10}
            onClick={() => {
              if (progress.done) {
                onDelete();
              }
            }}
          />
          {dataType === 'web' && (
            <IconRefresh
              className={classes.icon}
              id="icon-refresh-all"
              width={20}
              height={20}
              color={!progress.done ? color.$9 : color.$12}
              hoverColor={!progress.done ? color.$9 : color.$10}
              onClick={() => {
                if (progress.done) {
                  onRefresh();
                }
              }}
            />
          )}
        </div>
      )}
    </>
  );
};

export default Selected;
